import React, { useEffect, useState } from "react";
import { postData } from "../../assets/Json/staticData";
import { IconButton, Paper, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import YoutubeImg from '../../assets/images/youtube.jpg'
import DefaultImg from '../../assets/images/jb_link_img.jpg'
import Seo from "../../components/Seo/Seo";

const Blog = () => {
  const navigate = useNavigate();
  const { blogs, status, error } = useSelector((state) => state.blogs);
  const [blogList, setBlogList] = useState([]);
  const [newPost, setNewPost] = useState("");
  
    useEffect(()=>{
      setBlogList(blogs)
    },[blogs])
  // useEffect(()=>{
  //   setBlogList(postData.reverse())
  // },[])
  const handleClick = (post) => {
    if(post?.isVideoLink){
      post.videoId = getYouTubeVideoId(post?.urls?.YouTube)
    }
    navigate("/blog-details", { state: post });
  };


  const getYouTubeVideoId = (url) => {
    const regex =
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  function getYouTubeThumbnail(url) {
  const regExp = /(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([^?&]+)/;
  const match = url.match(regExp);
  if (match && match[1]) {
    const videoId = match[1];
    return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
  }
  return null;
}
  
  return (
    <>
      <Seo
        title="Architecture Blog | Tips & Ideas from JB Architects & Engineers, Tirunelveli"
        description="Read expert articles on choosing an architect in Tirunelveli, the cost of building a house, modern elevation ideas, and how to design for natural light and airflow."
        keywords={[
          "how to choose an architect in tirunelveli",
          "cost of building a house in tirunelveli",
          "modern house elevation design ideas",
          "how to maximize natural light and airflow in home design",
          "showroom architectural design ideas",
        ]}
        path="/blog"
      />
      <Typography variant="h5" color="orange" textAlign="center" className="mt-4" >
        Blogs
      </Typography>
      <div className="row p-4" style={{ marginRight: "0px" }}>
        {blogList?.map((post, idx) => {
          return (
            <div className="col-md-4 p-2" key={idx} onClick={() => handleClick(post)}>
              <Paper elevation={3} className="p-2" sx={{
                '&:hover': {
      // backgroundColor: '#f0f0f0',
      transform: 'scale(1.02)',
      boxShadow: 6,
      cursor: "pointer"
    },
              }}>
                <div style={{ display: "flex", width: "100%", height: "12em", overflow:'auto'}}>
                  <div style={{ width: "50%" }} className="p-2">
                    <p style={{ color: "red", fontWeight: "bold" }}>{post?.title}</p>
                    <p className="truncated-text">{post?.context}</p>
                  </div>
                  <div style={{ width: "50%" }} className="square-image">
                    {post?.mediaType === 'image' && 
                      <img
                        src={post?.image || DefaultImg }
                        alt="top architects consultant in tirunelveli"
                        className="post-image"
                      />
                    }  
                    {post?.mediaType === 'youtubeVideo' ? (
                      <img
                        src={ post?.youtube ? getYouTubeThumbnail(post?.youtube) : {DefaultImg}}
                        alt="top architects consultant in tirunelveli"
                        className="post-image"
                      />) : <></>
                    }
                  </div>
                </div>
              </Paper>
            </div>
          )
        })}
      </div>
    </>
  );
}

export default Blog;